import React, { useRef } from 'react';
import { Translate } from '../../../config/TranslationProvider';
import useScrollObserver from '../../../util/useScrollObserver';

import './ScrollTopButton.scss';

const ScrollTopButton = () => {
    const btnRef = useRef();

    const handleScroll = () => {
        if (!btnRef.current) {
            return;
        }

        if (window.scrollY >= 500) {
            // Hide the button
            btnRef.current.removeAttribute('inert');
            btnRef.current.style.transform = 'translateY(0)';
        } else {
            btnRef.current.setAttribute('inert', '');
            btnRef.current.style.transform = 'translateY(26px)';
        }
    };

    useScrollObserver(handleScroll);

    const handleScrollTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        btnRef.current.blur();
    };

    return (
        <button ref={btnRef} type="button" id="scrollBtn" onClick={handleScrollTop} className="fixedBottomButton scrollTopButton" inert="true">
            <i className="la la-angle-double-up icon-to-top" />
            <div className="text-to-top">
                <Translate value="scrollToTop" />
            </div>
        </button>
    );
};

export default ScrollTopButton;
